// extracted by mini-css-extract-plugin
export default {"DiscountCode":"styles_DiscountCode__jqjZL","title":"styles_title__6seIS","row":"styles_row__eUePF","code":"styles_code__6xZf+","copyButton":"styles_copyButton__iGSWV"};